import { Json } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import { ProjectRole } from 'src/modules/common/types/ProjectRole';

export const PROJECT_ROLE: C.Codec<unknown, Json, ProjectRole> = C.literal(
  ProjectRole.VIEWER,
  ProjectRole.EDITOR,
);
